var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintRoundedGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#EBFBFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_325_3723)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.7458 44.3787C29.7913 44.3787 30.8368 43.9802 31.6324 43.1846L42.1109 32.7061C42.6538 32.1633 42.6538 31.2858 42.1109 30.7429L30.6799 19.3119C30.137 18.7691 29.2596 18.7691 28.7167 19.3119L18.2368 29.789C16.6457 31.3802 16.6457 33.971 18.2368 35.5621L25.8579 43.1832C26.6549 43.9802 27.7003 44.3787 28.7458 44.3787ZM29.6983 22.2554L39.166 31.7231L39.005 31.8842H20.114C20.1473 31.8425 20.1626 31.7912 20.2014 31.7523L29.6983 22.2554Z",
    fill: "#18A7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6034 40.7938C39.6034 42.7709 41.1612 44.3801 43.0744 44.3801C44.9877 44.3801 46.5455 42.7709 46.5455 40.7938C46.5455 39.1998 44.5545 36.0551 43.9436 35.1304C43.559 34.5444 42.5899 34.5444 42.2053 35.1304C41.5944 36.0551 39.6034 39.1998 39.6034 40.7938Z",
    fill: "#18A7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_325_3723"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintRoundedGreen);
export default __webpack_public_path__ + "static/media/paint-rounded-green.a34ae05bd0bde15335be25ff981ba063.svg";
export { ForwardRef as ReactComponent };